import { ThreadPrimitive } from '@assistant-ui/react';
import { type FC } from 'react';
import './Suggestions.scss';

interface Props {
  readonly suggestions: readonly string[] | undefined;
}

export const Suggestions: FC<Props> = ({ suggestions }) => {
  if (suggestions?.length) {
    return (
      <div className={'chat-suggestions'}>
        <div className={'columns'}>
          {suggestions.map((prompt, idx) => (
            <div key={idx} className={'column is-one-third'}>
              <ThreadPrimitive.Suggestion
                prompt={prompt}
                clearComposer
                send
                className={'button is-fullwidth is-rounded is-soft'}
              >
                {prompt}
              </ThreadPrimitive.Suggestion>
            </div>
          ))}
        </div>
      </div>
    );
  } else {
    return null;
  }
};
Suggestions.displayName = 'Suggestions';
